import React, {MouseEvent} from 'react';
import {To, useLocation, useNavigate} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import IconButton from './IconButton';
import Back from '../icons/General/Back';

interface IBackButtonProps {
    to: To,
    text?: string,
    className?: string,
}

const BackButton: React.FC<IBackButtonProps> = ({to, text, className}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const onIconButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        if (location.key === 'default') {
            navigate(to);
        } else {
            navigate(-1);
        }
    };

    return (
        <IconButton icon={<Back/>} title={text ?? t`Назад`} onClick={onIconButtonClick} className={className}/>
    );
};

export default BackButton;
